import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { versionLabel, versionDetail } from './versionInfo';

/**
 * PGSS-5442. The running version, readable off the screen by anyone — staff, customer or supplier.
 *
 * Renders nothing when the build was not stamped, rather than showing a placeholder. A version that
 * is wrong is worse than one that is absent, because people act on it.
 */
function AppVersion({ className = '' }) {
  const label = versionLabel();
  if (!label) return null;

  return (
    <Tooltip title={versionDetail()} placement="top">
      <Typography
        className={`text-11 opacity-60 ${className}`}
        component="span"
        data-testid="app-version"
      >
        {label}
      </Typography>
    </Tooltip>
  );
}

export default AppVersion;
